"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ssr = require("./utils/ssr");

var bidders = []; // Bidder code (like Prebid) can rely on the window variable,
// so we can't load bidders when rendering server-side.

if ((0, _ssr.isClientSide)()) {
  var prebidBidder = require("./providers/prebid/prebidBidder").default;

  var amazonBidder = require("./providers/amazon/amazonBidder").default;

  var indexExchangeBidder = require("./providers/indexExchange/indexExchangeBidder").default;

  bidders = [prebidBidder, amazonBidder, indexExchangeBidder];
}
/**
 * On the client side, return an array of active bidders.
 * In a server environment, return an empty array.
 * @return {Bidder[]}
 */


var getBidders = function getBidders() {
  return bidders;
};

var _default = getBidders;
exports.default = _default;